import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import { Folder, Print, Star } from '@material-ui/icons'
import '../../../../../css/resources.sass'
import CoachingBestPractices from './best-practices'
import PrintMaterials from './print-materials'
import { ThemeContext } from 'styled-components'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const ResourceListContainer = styled.div`
  display: flex;

  @media(max-width: 900px) {
    flex-direction: column;
  }
`

const CategoryContainer = styled.div`
  flex-shrink: 0;
  padding-right: 32px;
  width: 285px;

  @media(max-width: 900px) {
    padding: 0px 0px 32px 0px;
    width: 100%;
  }
`

const SelectCategory = styled.p`
  background: ${props => props.active ? '#efefef' : 'none'};
  border-radius: 6px;
  color: ${props => props.active ? props.theme.color.secondary : '#555'};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family:  ${props => props.theme.font.primary};
  font-weight: 500;
  padding: 12px 16px;
  margin-bottom: 12px;
  transition: 0.3s ease all;

  &:hover {
    color: ${props => props.theme.color.secondary };

    svg {
      fill: ${props => props.theme.color.secondary };
    }
  }

  svg {
    margin-right: 12px;
    fill: ${props => props.active ? props.theme.color.secondary : '#555'};
  }
`

const ResourceContainer = styled.div`
  width: 100%;
  padding: 0 20pt;
`

const ResourceList = (props) => {
  const theme = useContext(ThemeContext)
  const [category, updateCategory] = useState(theme.name === 'AVATAR' ? 'coaching-best-practices' : 'instructional-videos')

  const renderResource = (category) => {
    switch(category) {
      case 'coaching-best-practices':
        return <CoachingBestPractices />
      case 'print-materials':
        return <PrintMaterials />
      default:
        return null
    }
  }

  return (
    <Container className={props.className}>
      <Label>
        <Folder /> Resources
      </Label>
      <ResourceListContainer>
        <CategoryContainer>
          {theme.name === 'AVATAR' && <SelectCategory active={(category === 'coaching-best-practices')} onClick={() => updateCategory('coaching-best-practices')}><Star /> Coaching Best Practices</SelectCategory>}
          {theme.name === 'AVATAR' && <SelectCategory active={(category === 'print-materials')} onClick={() => updateCategory('print-materials')}><Print /> Print Materials</SelectCategory>}
        </CategoryContainer>
        <ResourceContainer>
          {renderResource(category)}
        </ResourceContainer>
      </ResourceListContainer>
    </Container>
  )
}

export default ResourceList